import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BulletList, BulletListItem, Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const GetAbacorHeaderTID = (parentTestId)=>getTestIds(parentTestId);
export const AbacorHeader = ()=>{
    const { t: abacorTexts } = useLocaleKeys('integrations.setup.abacor');
    const { t: sharedTexts } = useLocaleKeys('integrations.apps.shared');
    const { AbacorHeaderTestIds } = useMemo(()=>GetAbacorHeaderTID(), []);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        alignItems: "start",
        testId: AbacorHeaderTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                children: [
                    abacorTexts.overviewDescription(),
                    ' ',
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://help.sayanchor.com/en/articles/16832804-abacor",
                        openInNewTab: true,
                        testId: AbacorHeaderTestIds.HelpCenterLink(),
                        bi: {
                            name: 'abacor_help_center_link'
                        },
                        children: sharedTexts.readMore()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                children: abacorTexts.whatYouCanDo()
            }),
            /*#__PURE__*/ _jsxs(BulletList, {
                spacing: "compact",
                children: [
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: abacorTexts.capabilities.serviceCatalogImport()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: abacorTexts.capabilities.meetingBasedProposals()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: abacorTexts.capabilities.fasterOpportunityDetection()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: abacorTexts.capabilities.lessManualDrafting()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: abacorTexts.capabilities.tighterFeedbackLoop()
                    })
                ]
            })
        ]
    });
};
